import initialState from '../../demoData/usersData.json';

const userReducer = (state = initialState) => {
  return state;
};

export { userReducer };
